// Redux Actions
import SET_ALLOW_ACCESS, {
  SET_API,
  API_PATCH_ENDPOINT,

  SET_BACKEND,

  SET_CONNECT,
  SET_SUBSCRIPTION,
  ADD_FREEMIUM_TRACKS_LOAD,
  SET_USER,
  SET_USER_PARAMETER,
  SET_AUTH,
  SET_AUTH_RESPONSE,
  SET_AUTH_STORE,
  SET_PRO_PLUS,
  SET_LINKAGE,

  SET_REGISTRATION,

  SET_ROUTE_STORE,

  SET_DIMENSION,

  SET_STORE_PLAYLISTS,
  SORTABLE_STORE_PLAYLISTS,
  NEW_STORE_PLAYLISTS,
  NEW_LOCAL_STORE_PLAYLISTS,
  UPDATE_STORE_PLAYLISTS,
  PUSH_STORE_PLAYLISTS,
  REMOVE_STORE_PLAYLISTS,
  INC_STORE_PLAYLISTS,
  SET_EXTRA_PLAYLISTS,
  ADD_EXTRA_PLAYLISTS,
  REFRESH_STORE_PLAYLISTS,
  SAVE_LOCAL_PLAYLIST,
  SET_PLAYLIST_TRACKS_ADDED,

  SET_STORE_HISTORY,
  UPDATE_STORE_HISTORY,
  HISTORY_PREV,
  HISTORY_NEXT,

  SET_STORE_LIST,
  SET_SELECTED_ITEMS,
  ADD_SELECTED_ITEMS,
  UNSELECTED_ITEMS,
  ADD_DRAG_ITEMS,
  CLEAR_DRAG_ITEMS,
  SET_DROPBOX,
  CLEAR_DROPBOX,

  SET_MODAL,
  SET_CONTEXT_MENU,

  SET_HISTORY_TRACKS,
  ADD_HISTORY_TRACKS,
  REMOVE_HISTORY_TRACKS,
  CLEAR_HISTORY_TRACKS,

  SET_ONAIR,

  SET_PLAYER_PREVIEW,
  SET_AUDIO_PREVIEW,
  SET_POSITION_PREVIEW,

  ADD_REPLAY_TRACKS,
  SET_REPLAY_TRACKS,

  SET_TICK_ITEM_ID,
  SET_CURRENT_LIST_BOUNDARIES,

  SET_DRAG_PLAYER,
  SET_STATE_SCROLLING,
  SET_STATE_FULLSCREEN,
  SET_STATE_CLEAR_FILTERS,
  SET_READY_BOOST_FILTERS,
  SET_LIST_CONTAINER_REF,

  SET_REQUEST_ERROR,
  SET_FIRST_LOG,

  SET_LAYOUT_TABLET,
  TOGGLE_LAYOUT_TABLET,
  SET_TOUCH_EDITOR,

  /** TOAST **/
  ADD_TOAST,
  REMOVE_TOAST,

  /** POPUP **/
  SET_POPUP,
  SET_STORE_POPUP,

  /** TAB BAR **/
  SET_TAB_BAR,
  RESET_TAB_BAR,

  /** SPLASH **/
  SET_SPLASH_STATE,
  SET_SPLASH_LOADING,
  SET_SPLASH_ERROR,

  SET_BROWSER_OPTIMAL,
  SET_BANNER_BROWSER

} from "../types";


/** API **/

export function setAPI(payload) {
  return { type: SET_API, payload }
};

export function patchEndpoint(endpoint, value) {
  return { type: API_PATCH_ENDPOINT, endpoint, value }
};

/** BACKEND **/

export function setBackend(payload) {
  return { type: SET_BACKEND, payload }
};

/** AUTHENTIFICATION **/

export function setConnect(payload) {
  return { type: SET_CONNECT, payload }
};

export function setSubscription(payload) {
  return { type: SET_SUBSCRIPTION, payload }
};

export function addFreemiumTracksLoad(payload = null) {
  return { type: ADD_FREEMIUM_TRACKS_LOAD, payload }
};

export function setUser(payload) {
  return { type: SET_USER, payload }
};

export function setUserParameter(parameter, value) {
  return { type: SET_USER_PARAMETER, parameter, value }
};

export function setAuth(payload) {
  return { type: SET_AUTH, payload }
};

export function setAuthResponse(payload) {
  return { type: SET_AUTH_RESPONSE, payload }
};

export function setStoreAuth(payload) {
  return { type: SET_AUTH_STORE, payload }
};

export function setProPlus(payload) {
  return { type: SET_PRO_PLUS, payload }
};

export function setLinkage(payload) {
  return { type: SET_LINKAGE, payload }
};

/** REGISTRATION **/

export function setRegistration(payload) {
  return { type: SET_REGISTRATION, payload }
};

/** ROUTE - WRAPPER / STORE **/

export function setStoreRoute(payload) {
  return { type: SET_ROUTE_STORE, payload }
};

/** DIMENSION **/

export function setDimension(payload) {
  return { type: SET_DIMENSION, payload }
};

/** PLAYLISTS **/

export function setStorePlaylists(payload) {
  return { type: SET_STORE_PLAYLISTS, payload }
};

export function sortableStorePlaylists(trackID, endIndex) {
  return { type: SORTABLE_STORE_PLAYLISTS, trackID, endIndex }
};

export function newStorePlaylists(name, data, extra = {}) {
  return { type: NEW_STORE_PLAYLISTS, name, data, extra }
};

export function saveLocalPlaylist(id, name, extra = {}) {
  return { type: SAVE_LOCAL_PLAYLIST, id, name, extra }
};

export function newLocalStorePlaylists(id, name, data, extra = {}) {
  return { type: NEW_LOCAL_STORE_PLAYLISTS, id, name, data, extra }
};

export function updateStorePlaylists(trackID, property, data) {
  return { type: UPDATE_STORE_PLAYLISTS, trackID, property, data }
};

export function pushStorePlaylists(trackID, property, data) {
  return { type: PUSH_STORE_PLAYLISTS, trackID, property, data }
};

export function incrementStorePlaylists(trackID, property, data) {
  return { type: INC_STORE_PLAYLISTS, trackID, property, data }
};

export function removeStorePlaylists(trackID) {
  return { type: REMOVE_STORE_PLAYLISTS, trackID }
};

export function setExtraPlaylists(extra) { // FROM BDD
  return { type: SET_EXTRA_PLAYLISTS, extra }
}

export function addExtraPlaylists(extra) { // FROM BDD
  return { type: ADD_EXTRA_PLAYLISTS, extra }
}

export function refreshStorePlaylists() {
  return { type: REFRESH_STORE_PLAYLISTS }
}

export function setPlaylistTracksAdded(id) {
  return { type: SET_PLAYLIST_TRACKS_ADDED, id }
};

/** HISTORY (NAVIGATOR) **/

export function setStoreHistory(payload) {
  return { type: SET_STORE_HISTORY, payload }
};

export function updateStoreHistory(path) {
  return { type: UPDATE_STORE_HISTORY, path }
};

// V2
export function historyPrev() {
  return { type: HISTORY_PREV }
};

export function historyNext() {
  return { type: HISTORY_NEXT }
};

/** SELECTED ITEMS - D&D **/

export function setStoreListRedux(payload) {
  return { type: SET_STORE_LIST, payload }
};

export function setSelectedItems(payload) {
  return { type: SET_SELECTED_ITEMS, payload }
};

export function addSelectedItems(payload) {
  return { type: ADD_SELECTED_ITEMS, payload }
};

export function unSelectedItems() {
  return { type: UNSELECTED_ITEMS }
};

export function addDragItems() {
  return { type: ADD_DRAG_ITEMS }
};

export function clearDragItems() {
  return { type: CLEAR_DRAG_ITEMS }
};

export function setDropbox(payload) {
  return { type: SET_DROPBOX, payload }
};

export function clearDropbox() {
  return { type: CLEAR_DROPBOX }
}

/** MODAL **/

export function setModal(payload) {
  return { type: SET_MODAL, payload }
};

/** CONTEXT MENU **/

export function setContextMenu(payload, options = null) {
  return { type: SET_CONTEXT_MENU, payload, options }
};

/** HISTORY TRACKS **/

export function setHistoryTracks(payload) {
  return { type: SET_HISTORY_TRACKS, payload }
};

export function addHistoryTracks(payload) {
  return { type: ADD_HISTORY_TRACKS, payload }
};

export function removeHistoryTracks(trackID) {
  return { type: REMOVE_HISTORY_TRACKS, trackID }
};

export function clearHistoryTracks() {
  return { type: CLEAR_HISTORY_TRACKS }
};

/** ON AIR **/

export function setOnAir(pid, trackID) {
  return { type: SET_ONAIR, pid, trackID }
};

/** PREVIEW  **/

export function setPlayerPreview(player) {
  return { type: SET_PLAYER_PREVIEW, player }
};

export function setAudioPreview(audio) {
  return { type: SET_AUDIO_PREVIEW, audio }
};

export function setPositionPreview(idParent, position) {
  return { type: SET_POSITION_PREVIEW, idParent, position }
};

/** REPLAY **/

export function addReplayTracks(trackID) {
  return { type: ADD_REPLAY_TRACKS, trackID }
};

export function setReplayTracks(tracks) {
  return { type: SET_REPLAY_TRACKS, tracks }
};

/** LIST **/

export function setTickItemID(payload) {
  return { type: SET_TICK_ITEM_ID, payload }
};

export function setCurrentListBoundaries(payload) {
  return { type: SET_CURRENT_LIST_BOUNDARIES, payload }
};

/** D&D **/

export function setDragPlayer(pid, audio) {
  return { type: SET_DRAG_PLAYER, pid, audio }
};

export function setStateScrolling(payload) {
  return { type: SET_STATE_SCROLLING, payload }
};

export function setStateFullScreen(payload) {
  return { type: SET_STATE_FULLSCREEN, payload }
};

export function setStateClearFilters(payload) {
  return { type: SET_STATE_CLEAR_FILTERS, payload }
};

export function setReadyBoostFilters(payload) {
  return { type: SET_READY_BOOST_FILTERS, payload }
};

export function setListContainerRef(payload) {
  return { type: SET_LIST_CONTAINER_REF, payload }
};

/** ERRORS **/

export function setRequestError(payload) {
  return { type: SET_REQUEST_ERROR, payload }
};

export function setFirstLog(payload) {
  return { type: SET_FIRST_LOG, payload }
};

/** TABLET **/

/** TOUCH / LAYOUT **/

export function setLayoutTablet(payload) {
  (window['YouDJ'] && window['YouDJ'].set_layout_tablet) && window['YouDJ'].set_layout_tablet(payload);
  return { type: SET_LAYOUT_TABLET, payload }
};

export function toggleLayoutTablet() {
  return { type: TOGGLE_LAYOUT_TABLET }
}

export function setTouchEditor(payload) {
  return { type: SET_TOUCH_EDITOR, payload }
};

/** TOAST **/

export function addToast(payload) {
  return { type: ADD_TOAST, payload }
}

export function removeToast(payload) {
  return { type: REMOVE_TOAST, payload }
}

/** POPUP **/

export function setPopup(payload) {
  return { type: SET_POPUP, payload }
};

export function setStorePopup(payload) {
  return { type: SET_STORE_POPUP, payload }
};

/** GENERAL **/

export function setAllowAccess(payload) {
  return { type: SET_ALLOW_ACCESS, payload }
}

/** TAB BAR **/

export function setTabBar(payload) {
  return { type: SET_TAB_BAR, payload }
}

export function resetTabBar() {
  return { type: RESET_TAB_BAR }
}

/** SPLASH **/

export function setSplashState(payload) {
  return { type: SET_SPLASH_STATE, payload }
}

export function setSplashLoading(payload) {
  return { type: SET_SPLASH_LOADING, payload }
}

export function setSplashError(payload) {
  return { type: SET_SPLASH_ERROR, payload }
}

export function setBrowserOptimal(payload) {
  return { type: SET_BROWSER_OPTIMAL, payload }
}

export function setBannerBrowser(payload) {
  return { type: SET_BANNER_BROWSER, payload }
}

